<template>
  <div class="details-container-box">
    <div class="details-container-title" @click="$emit('showDetails')">
      <div class="chevron-div">
        <h4 class="details-inline-element">{{ videoDetails.name }}</h4>
        <img
          src="../assets/img/arrow-right.png"
          class="chevron"
          :class="{ 'chevron-up': showLensDetails && !isLocked }"
          alt=""
        />
      </div>
      <span class="details-pill">{{ LENS_DETAILS_LABEL }}</span>
    </div>
    <Transition name="expand">
      <LensDetailsContent
        v-if="showLensDetails && !isLocked"
        :details="videoDetails"
        :sampleImages="sampleImages"
        :side="side"
      />
    </Transition>
  </div>
</template>
<script setup>
import { getSampleImages } from '@/api/sampleImages'
import { useLensesStore } from '@/stores/Lenses'
import { computed, defineProps, onMounted, ref, watch } from 'vue'
import LensDetailsContent from './LensDetailsContent.vue'
import { LENS_DETAILS_LABEL } from '@/utils/constants'

const sampleImages = ref([])

const lensStore = useLensesStore()

const props = defineProps({
  videoDetails: Object,
  side: String,
  showLensDetails: Boolean
})

// Locked only for a premium lens viewed by a non-premium user - free lenses
// always show full specs/samples regardless of the viewer's own plan.
const isLocked = computed(() => props.videoDetails?.isPremium === true && !lensStore.isPremiumUser)

const fetchSampleImages = async () => {
  sampleImages.value = []

  if (isLocked.value) return

  const response = await getSampleImages(props.videoDetails.genericId)
  if (response.data) {
    sampleImages.value = response.data.images
  }

  // Specific lens sample images
  const specificSampleImages = props.videoDetails?.sampleImages

  if (specificSampleImages) {
    sampleImages.value = [...sampleImages.value, ...specificSampleImages]
  }
}

onMounted(async () => {
  await fetchSampleImages()
})

watch(
  () => props.videoDetails.genericId,
  async () => {
    await fetchSampleImages()
  }
)
</script>
<style scoped>
.left-column {
  flex: 1;
  margin: 4px;
}
.chevron-div {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.chevron {
  width: 12px;
  transform: rotate(90deg);
  transition: all 0.3s;
}
.chevron-up {
  transform: rotate(270deg);
}
</style>
